import What from '@icons/What'
import { styled, Typography } from '@mui/material'

/**
 * `height: calc(100vh - 180px)` used to hardcode a chrome height that matches
 * no constant at any of the seven call sites, which parked the block ~36% down
 * the viewport. The parent owns the viewport now; `minHeight` is a prop.
 */
export const Root = styled('div', {
  shouldForwardProp: (propName: PropertyKey) => propName !== 'minHeight',
})<{ minHeight: string }>(({ theme, minHeight }) => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  minHeight,
  padding: theme.spacing(4, 0),
  width: '100%',
}))

export const Container = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
    padding: theme.spacing(3),
    width: '100%',
  },
  alignItems: 'center',
  display: 'grid',
  gap: theme.spacing(4),
  gridTemplateColumns: '1fr 1fr',
  margin: '0 auto',
  maxWidth: '102rem',
  width: '100%',
}))

export const InnerContainer = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    order: 1,
    textAlign: 'center',
  },
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  justifyContent: 'center',
}))

export const Header = styled(Typography)({
  fontWeight: 600 as const,
})

export const Body = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
}))

export const ButtonContainer = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
  marginTop: theme.spacing(2),
}))

export const Conjunction = styled('div')(({ theme }) => ({
  color: theme.palette.text.secondary,
  display: 'inline-block',
  margin: theme.spacing(0, 0.5),
}))

/**
 * `What` is a plain `<svg>` now, so it honours width/height directly. The old
 * rule targeted a nested `svg` that never existed, leaving the illustration at
 * SvgIcon's 1.5rem default — about 12px — with the 488:359 artwork letterboxed
 * inside it. `text.disabled` keeps it a watermark in both modes.
 */
export const NotFoundImage = styled(What)(({ theme }) => ({
  color: theme.palette.text.disabled,
  height: 'auto',
  maxWidth: '48.8rem',
  width: '100%',
}))
